var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Chart_Bar_Vertical_01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.75 8.25V15M6.75 8.25H3.44971C3.02967 8.25 2.81986 8.25 2.65942 8.33175C2.5183 8.40365 2.40365 8.5183 2.33175 8.65942C2.25 8.81986 2.25 9.03003 2.25 9.45007V15H6.75M6.75 8.25V4.20007C6.75 3.78003 6.75 3.56986 6.83175 3.40942C6.90365 3.2683 7.0183 3.15365 7.15942 3.08175C7.31986 3 7.52967 3 7.94971 3H10.0497C10.4697 3 10.6802 3 10.8406 3.08175C10.9818 3.15365 11.0961 3.2683 11.168 3.40942C11.2497 3.56986 11.25 3.78003 11.25 4.20007V6M6.75 15H11.25M11.25 15L15.75 15.0001V7.20007C15.75 6.78003 15.7497 6.56986 15.668 6.40942C15.5961 6.2683 15.4822 6.15365 15.3411 6.08175C15.1806 6 14.97 6 14.55 6H11.25M11.25 15V6",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.d14842408dd093bab3a0cd6c739b2d28.svg";
export { ForwardRef as ReactComponent };